import { ReactElement, useRef } from 'react';
import { RouteData } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import { getSharedArray } from '../../../getters';
import { JabraFocusGroup } from '../../JabraFocus';
import { MajorLinkCards, MinorLinksCategoryItem } from '../common';
import { submenuComponentsMap } from '../headerComponentsMapper';
import { DISPLAY_VERSIONS } from '../MegaMenuConstants';
import { MajorLinksCategory, MinorLinksCategory } from '../MegaMenuTypes';
import { useHeaderNavigation } from '../providers';
import { DesktopMajorLinksCategory } from './DesktopMajorLinksCategory';

import styles from '../MegaMenu.module.css';

export const DesktopSubmenu = (): ReactElement | null => {
  const { activeSubmenuItem, activeItemId, route } = useHeaderNavigation();
  const detailsPanel = useRef<HTMLDivElement>(null);

  if (!activeSubmenuItem && activeItemId) {
    return activeItemId ? submenuComponentsMap[activeItemId]?.(route as RouteData) : null;
  }

  if (!activeSubmenuItem) {
    if (submenuComponentsMap[activeItemId]) {
      return submenuComponentsMap[activeItemId]?.(route as RouteData);
    }

    return null;
  }
  const majorLinksCategories: MajorLinksCategory[] = getSharedArray(
    activeSubmenuItem.fields,
    'MajorLinksCategories'
  );
  const minorLinksCategories: MinorLinksCategory[] = getSharedArray(
    activeSubmenuItem.fields,
    'MinorLinksCategories'
  );

  return (
    <div className={`hidden lg:block ${DISPLAY_VERSIONS.DESKTOP} submenu relative`} role="menu">
      <div
        className={classNames('flex-column absolute top-0 w-full bg-white', styles.desktopSubmenu)}
      >
        <JabraFocusGroup orientation="horizontal" id="submenu">
          <div className="flex flex-1 flex-row p-8">
            {majorLinksCategories.length > 0 ? (
              <div className="flex min-w-fit flex-col pr-4">
                {majorLinksCategories.map((category) => (
                  <DesktopMajorLinksCategory
                    key={category.displayName}
                    category={category}
                    detailsPanel={detailsPanel.current}
                  />
                ))}
              </div>
            ) : null}

            <div ref={detailsPanel} className="flex-1">
              <JabraFocusGroup id="major-link-cards">
                <MajorLinkCards />
              </JabraFocusGroup>
            </div>
          </div>
        </JabraFocusGroup>
        <JabraFocusGroup>
          {minorLinksCategories.length > 0 ? (
            <div className="flex flex-col gap-2 bg-infographicBgGrey1 p-8 pb-7 pt-7">
              {minorLinksCategories.map((category) => (
                <MinorLinksCategoryItem
                  key={category.displayName}
                  category={category}
                  displayVersion={DISPLAY_VERSIONS.DESKTOP}
                />
              ))}
            </div>
          ) : null}
        </JabraFocusGroup>
      </div>
    </div>
  );
};
